import * as next from 'next'

import * as core from '@boutique/services'
import * as url from '@boutique/url'

export { ProductDetail as default } from '@boutique/product'

import { type ProductPageProps, getInitialSelectionState, formatOptions } from '@boutique/product'

export async function getServerSideProps(
  context: next.GetServerSidePropsContext<{ product: string }>,
): Promise<next.GetServerSidePropsResult<ProductPageProps>> {
  const productSlug = context.params?.product

  if (!productSlug) {
    return {
      notFound: true,
    }
  }

  const splitSlug = productSlug.split('-')
  const productId = splitSlug[splitSlug.length - 1]

  const result = await core.product.client.getProduct(Number(productId))

  const product = result.caseOf({
    right: (success) => success,
    left: () => null,
  })

  if (product === null) {
    return {
      notFound: true,
    }
  }

  const productHandle = splitSlug.slice(0, -1).join('-')
  if (productHandle !== product.handle) {
    return {
      redirect: {
        destination: url.product({
          handle: product.handle,
          id: Number(product.numericId),
          title: product.title,
        }).path,
        statusCode: 301,
      },
    }
  }
  const formattedOptions = formatOptions(product)
  return {
    props: {
      product,
      productId,
      initialSelectionState: getInitialSelectionState(product, formattedOptions),
      formattedOptions,
    },
  }
}
